import React from "react";
import { useState, useEffect } from "react";
// import axios from "axios";
import i from "../Images/c3.jpg";
const Dashboard = () => {
  const url = "https://api.rootnet.in/covid19-in/stats/latest";

  const [data, setData] = useState([]);

  useEffect(() => {
    // axios.get(url).then(json => setData(json.data.data))
    fetch(url)
      .then((response) => response.json())
      .then((data) => setData(data.data.summary));
  }, []);

  // const renderTable = () => {
  //   return data.map(data => {
  //     return (
  //       <tr>
  //         <td>{data.total}</td>
  //         <td>{data.discharged}</td>
  //         <td>{data.deaths}</td>
  //       </tr>
  //     )

  // }
  return (
    <div>
      {/* <table id="users"> 
        <thead>
          <tr>
            <th>Total</th>
            <th>Discharge</th>
            <th>Deaths</th>
            
          </tr>
        </thead> */}
      {/* <tbody>{renderTable()}</tbody> */}
      {/* </table> */}

      <div class="container z-depth-1 my-5 pt-5 pb-3 px-5">
        <section>
          <h1 class="font-weight-bold text-center dark-grey-text pb-2">
            India Corona Dashboard
          </h1>
          <hr class="w-header my-4" />
          {/* <p class="lead text-center text-muted pt-2 mb-5"> */}
          <div class="progress m-2">
            <div
              class="progress-bar bg-danger progress-bar-striped progress-bar-animated"
              role="progressbar"
              style={{ width: "90%" }}
              aria-valuenow="90"
              aria-valuemin="0"
              aria-valuemax="100"
            > Cases : {data.total}</div>
          </div>
        
          <br />
          <div class="progress m-2">
            <div
              class="progress-bar bg-warning progress-bar-striped progress-bar-animated"
              role="progressbar"
              style={{ width: "60%" }}
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            >
               discharged : {data.discharged}
            </div>
          </div>
          <br />
          <div class="progress m-2">
            <div
              class="progress-bar bg-success progress-bar-striped progress-bar-animated"
              role="progressbar"
              style={{ width: "35%" }}
              aria-valuenow="75"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              deaths : {data.deaths}
            </div>
          </div>
          <br />
         
          {/* </p> */}

          <div class="row align-items-center">
            <div class="col-lg-7 mb-4">
              <img src={i} className="img-fluid animated" alt="home-img" />
            </div>

            <div class="col-lg-5 mb-4">
              <ol class="step pl-0">
                <li class="step-element pb-0">
                  <div class="step-number">
                    <span class="number">1</span>
                  </div>
                  <div class="step-excerpt">
                    <h6 class="font-weight-bold dark-grey-text mb-3">
                      India Total Cases
                    </h6>
                    <p class="text-muted">{data.total}</p>
                  </div>
                </li>
                <li class="step-element pb-0">
                  <div class="step-number">
                    <span class="number">2</span>
                  </div>
                  <div class="step-excerpt">
                    <h6 class="font-weight-bold dark-grey-text mb-3">
                      India discharged
                    </h6>
                    <p class="text-muted">{data.discharged}</p>
                  </div>
                </li>
                <li class="step-element pb-0">
                  <div class="step-number">
                    <span class="number">3</span>
                  </div>
                  <div class="step-excerpt">
                    <h6 class="font-weight-bold dark-grey-text mb-3">
                      India Deaths
                    </h6>
                    <p class="text-muted">{data.deaths}</p>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Dashboard;
